import { FC, PropsWithChildren } from "react";
// import { ReactLocationDevtools } from 'react-location-devtools';
import { Router } from "react-location";
import routes from "./routes";
import location from "./location";
import filterRoutes from "./filter";
// import { currentConfigVar } from "_graphql/cache/config";

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
  // const currentTheme = useReactiveVar(currentConfigVar);


  return (
    <div className={"light"}>
      <Router location={location} routes={routes} filterRoutes={filterRoutes()}>
        {/* <ReactLocationDevtools initialIsOpen={false} /> */}
        {children}
      </Router>
    </div>
  );
};

export default RoutesProvider;
